<template>
  <vue-final-modal
    :value="value"
    :name="name"
    :classes="['career-yagioffer-reset-dialog__container']"
    :styles="{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }"
    :content-class="[
      'career-yagioffer-reset-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="$emit('input', $event)"
  >
    <div class="v--modal-close-top">
      <el-button
        @click="$emit('input', false)"
        icon="el-icon-close"
        type="text"
      />
    </div>
    <div class="title">{{ title }}</div>
    <span>{{ message }}</span>
    <div :class="actionsClass">
      <el-button type="primary" @click="onConfirm">リセットする</el-button>
      <el-button @click="$emit('input', false)">リセットしない</el-button>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
defineProps<{
  value: boolean
  name: string
  title: string
  message: string
  /** 学歴モーダルは text-left、職歴は無し（見た目維持） */
  actionsClass?: string
}>()

const emit = defineEmits(['input', 'confirm'])

function onConfirm() {
  emit('input', false)
  emit('confirm')
}
</script>

<style lang="scss">
/* VFM は teleport のため non-scoped（旧 vue-js-modal 相当の見た目） */
.career-yagioffer-reset-dialog__container {
  z-index: 1000;
}

.career-yagioffer-reset-dialog__content.v--modal-box.v--modal {
  padding: 1.5rem;
  max-width: 90vw;
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 4px;
}

.career-yagioffer-reset-dialog__content .title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.75rem;
}

.career-yagioffer-reset-dialog__content .v--modal-close-top {
  text-align: right;
}
</style>
